import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useAppSelector } from "../hook";
import {
  assetTreeSelectionReducers,
  AssetTreeSelectionState,
  criarEstadoDeSelecaoDaArvore,
} from "../assetTreeSelectionReducers";

export type AssetTreeProps = AssetTreeSelectionState & {
  assets?: any[];
};

const initialState: AssetTreeProps = {
  assets: [],
  ...criarEstadoDeSelecaoDaArvore(),
};

export const VolksAssetTreeSlice = createSlice({
  name: "volksAssetTree",
  initialState,
  reducers: {
    ...assetTreeSelectionReducers,
    setAssets: (state, action: PayloadAction<any[]>) => {
      state.assets = action.payload;
    },
  },
});

export const { setSelectedCategories, setSelectedClients, setSelectedContracts, setSelectedVehicles, setAssets } =
  VolksAssetTreeSlice.actions;

export const getStoredSelectedCategories = (state: RootState) => state.volksAssetTree.selectedCategories;
export const getStoredSelectedClients = (state: RootState) => state.volksAssetTree.selectedClients;
export const getStoredSelectedContracts = (state: RootState) => state.volksAssetTree.selectedContracts;
export const getStoredSelectedVehicles = (state: RootState) => state.volksAssetTree.selectedVehicles;
export const getStoredAssets = (state: RootState) => state.volksAssetTree.assets;

export const useGetStoredSelectedCategories = () => useAppSelector(getStoredSelectedCategories);
export const useGetStoredSelectedClients = () => useAppSelector(getStoredSelectedClients);
export const useGetStoredSelectedContracts = () => useAppSelector(getStoredSelectedContracts);
export const useGetStoredSelectedVehicles = () => useAppSelector(getStoredSelectedVehicles);
export const useGetStoredAssets = () => useAppSelector(getStoredAssets);

export default VolksAssetTreeSlice.reducer;
